import { Link } from "react-router-dom";
import DiyaVisual from "../pooja/DiyaVisual";

export default function PoojaEnergizationSection() {
  return (
    <section className="py-20 bg-white md:px-16">
      <div className="container mx-auto max-w-350 px-6">
        <div className="relative rounded-[3rem] bg-[#140608] text-white overflow-hidden shadow-2xl border border-white/10">
          <div className="grid lg:grid-cols-2 items-center">
            <div className="relative overflow-hidden rounded-[2.5rem] p-10 md:p-14 text-white">
              <div className="relative z-10 space-y-8">
                <div className="flex items-center gap-5">
                  <div className="flex h-16 w-16 items-center justify-center rounded-3xl border border-white/10 bg-white/5 backdrop-blur-sm shadow-inner">
                    <i className="fa-solid fa-fire h-8 w-8 text-secondary flex items-center justify-center text-2xl"></i>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-white/50">Ritual Protocol</p>
                    <h3 className="font-heading text-3xl md:text-4xl leading-tight font-light">Pooja Energization</h3>
                  </div>
                </div>
                <p className="max-w-lg text-base md:text-lg leading-relaxed text-white/70 font-body">
                  Ensure 100% spiritual potency. Every shop item undergoes a high-precision ritual synchronization (<span className="text-secondary font-semibold">prana pratishtha</span>) by our master priests before dispatch.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-2.5 px-5 py-2 rounded-full border border-white/10 bg-white/5 text-[10px] font-medium uppercase tracking-widest text-white/60"><i className="fa-solid fa-shield-halved text-secondary"></i> Verified System</div>
                  <div className="flex items-center gap-2.5 px-5 py-2 rounded-full border border-white/10 bg-white/5 text-[10px] font-medium uppercase tracking-widest text-white/60"><i className="fa-solid fa-star text-secondary"></i> Energized Sync</div>
                </div>
                <Link
                  to="/pooja-energization"
                  className="group inline-flex items-center justify-center whitespace-nowrap py-3.5 px-10 rounded-2xl bg-secondary text-white font-semibold uppercase tracking-widest text-[11px] shadow-lg shadow-secondary/20 transition-all hover:bg-white hover:text-primary active:scale-95"
                >
                  Learn ritual process <i className="fa-solid fa-arrow-right ml-3 h-4 w-4 transition-transform group-hover:translate-x-1"></i>
                </Link>
              </div>
            </div>

            <div className="bg-black/20">
              <DiyaVisual />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
